import React from 'react';
import './style.css';

type checkboxType = {
  name: string,
  value: string,
  label: string,
  checked: boolean
}

interface Props {
  inputs: checkboxType[],
  title: string,
  handler: (e: React.FormEvent<HTMLInputElement>) => void
}

const CheckboxComponent: React.FC<Props> = ({inputs, title, handler}) => {

  return (
    <form id={`form-${title.replace(/[\\. ,:-]+/g, '')}`} className='flex js-sbw radio-form w-100 pos-rel'>
      <div className='radio-title'>{title}</div>
      <div className='w-50 flex al-it-c js-c'>
        {
          inputs.map((input: checkboxType, i: number) => {
            const {name, value, checked, label} = input;
            return (
              <div className={checked ? 'radio-btn-wrapper active' : 'radio-btn-wrapper'}
                   key={title + '' + i}
              >
                <label className='flex js-c al-it-c'>
                  <input
                    type="radio"
                    name={name}
                    value={value}
                    checked={checked}
                    className="radio-btn"
                    onChange={handler}
                  />
                  <span className="checkcircle"/>
                  {
                    checked && <span className="checkmark"></span>
                  }
                  {label}
                </label>
              </div>
            )
          })
        }
      </div>
    </form>
  )
};

export default CheckboxComponent